import { ThemeConfig } from 'antd/es/config-provider/context';

export const APP_THEME: ThemeConfig = {
  token: {
    borderRadius: 10,
    colorPrimary: '#edff6b',
    colorInfo: '#edff6b',
    colorText: '#888888',
    colorTextTertiary: 'rgb(136,136,136)',
    colorIcon: 'rgb(136,136,136)',
  },
  components: {
    Pagination: {
      colorText: 'rgb(136,136,136)',
      colorBgContainer: 'rgb(46,46,46)',
      colorTextDisabled: 'rgb(136,136,136)',
      itemBg: 'transparent',
    },
    Card: {
      colorBgContainer: 'rgb(46,46,46)',
      colorText: 'rgb(136,136,136)',
    },
    Layout: {
      bodyBg: 'rgb(0,0,0)',
      footerBg: 'rgb(0,0,0)',
      headerBg: 'rgb(0,0,0)',
      lightSiderBg: 'rgb(0,0,0)',
      lightTriggerBg: 'rgb(0,0,0)',
      siderBg: 'rgb(0,0,0)',
      triggerBg: 'rgb(0,0,0)',
    },
    Message: {
      contentBg: '#2E2E2E',
      colorText: 'rgb(136,136,136)',
    },
    Modal: {
      contentBg: 'rgb(46,46,46)',
      headerBg: 'rgb(46,46,46)',
      colorText: 'rgb(136,136,136)',
      titleColor: 'rgb(136,136,136)',
    },
    Input: {
      colorBorder: 'transparent',
      hoverBorderColor: 'transparent',
      colorPrimaryHover: 'transparent',
      colorPrimaryActive: 'transparent',
      activeBorderColor: 'transparent',
      activeShadow: 'none',
      colorBgContainer: '#202020',
      colorBgContainerDisabled: '#202020',
      colorTextDisabled: '#888888',
      colorText: '#888888',
      colorTextPlaceholder: 'rgba(136,136,136,0.6)',
    },
    InputNumber: {
      colorBorder: 'transparent',
      hoverBorderColor: 'transparent',
      colorPrimaryHover: 'transparent',
      colorPrimaryActive: 'transparent',
      activeBorderColor: 'transparent',
      activeShadow: 'none',
      colorBgContainer: '#202020',
    },
    Select: {
      hoverBorderColor: 'transparent',
      activeOutlineColor: 'transparent',
      activeBorderColor: 'transparent',
      selectorBg: '#202020',
      colorBgElevated: '#202020',
      optionSelectedColor: '#ffffff',
      optionSelectedBg: 'rgba(136,136,136,0.3)',
      colorPrimaryHover: 'rgba(136,136,136,0.3)',
      optionActiveBg: 'rgba(136,136,136,0.3)',
    },
    Button: {
      primaryColor: 'rgb(0,0,0)',
      boxShadow: 'none',
      primaryShadow: 'none',
      colorTextDisabled: '#888888',
      borderColorDisabled: 'transparent',
      colorBgContainerDisabled: 'rgba(136,136,136,0.3)',
      defaultColor: '#000000',
      colorText: '#888888',
      defaultActiveColor: '#000000',
      defaultHoverColor: '#000000',
      defaultBg: 'rgba(136,136,136,0.3)',
      defaultActiveBg: 'rgba(136,136,136,0.5)',
      defaultHoverBg: 'rgba(136,136,136,0.5)',
      defaultBorderColor: 'transparent',
      defaultHoverBorderColor: 'transparent',
      defaultActiveBorderColor: 'transparent',
      defaultShadow: 'none',
    },
    Table: {
      colorBgContainer: 'rgb(46,46,46)',
      colorTextTertiary: 'rgb(136,136,136)',
      colorIcon: 'rgb(136,136,136)',
    },
  },
  cssVar: true,
};
